import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Concierge from "@/components/Concierge";
import ReferralPopup from "@/components/ReferralPopup";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Fleet from "@/pages/Fleet";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Reviews from "@/pages/Reviews";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Confirmation from "@/pages/Confirmation";
import Admin from "@/pages/Admin";
import Invoice from "@/pages/Invoice";
import Corporate from "@/pages/Corporate";
import "@/App.css";

function Layout({ children }) {
  const loc = useLocation();
  const isAdminInvoice = loc.pathname.startsWith("/admin/dashboard") || loc.pathname.startsWith("/invoice") || loc.pathname.startsWith("/corporate/dashboard");
  return (
    <>
      <Nav />
      <main>{children}</main>
      {!isAdminInvoice && <Concierge />}
      {!isAdminInvoice && <ReferralPopup />}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#131519", color: "#F8FAFC", border: "1px solid rgba(212,175,55,0.28)" } }} />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/confirmation/:rn" element={<Confirmation />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/dashboard" element={<Admin />} />
            <Route path="/invoice/:invoiceNumber" element={<Invoice />} />
            <Route path="/corporate" element={<Corporate />} />
            <Route path="/corporate/dashboard" element={<Corporate />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
